/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Strength_TitleInputs */

const en_for_whom_strength_title = /** @type {(inputs: For_Whom_Strength_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stronger every week.`)
};

const pl_for_whom_strength_title = /** @type {(inputs: For_Whom_Strength_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silniejszy co tydzień.`)
};

/**
* | output |
* | --- |
* | "Stronger every week." |
*
* @param {For_Whom_Strength_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_strength_title = /** @type {((inputs?: For_Whom_Strength_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Strength_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_strength_title(inputs)
	return en_for_whom_strength_title(inputs)
});